import React from "react";
import { Link } from "react-router-dom";

import { getImgUrl } from "../../Utility/Utility";
import { Img } from "../../Components/UI/UI";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="Footer-outer-wrapper">
      <div className="container">
        <div className="row">
          <div className="col col-100 footer-menu-outer-wrapper">
            {/* <div className="footer-images-wrapper">
              <div className="tripadvisor-main-wrapper">
                <Img desktopImg="Footer/tripadvisorMain.png" />
              </div>
              <div className="info-main-wrapper">
                <a href="https://www.gov.il/en/service/virtual_office/">
                  <Img desktopImg="support.png" />
                </a>
              </div>
            </div> */}
            <div className="footer-menu-inner-wrapper footer-menu-inner-wrapper-1">
              <ul className="first">
                <li>
                  <Link className="first" to="/Pages/whereToGo">
                    A DONDE IR
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Pages/TelAvivPage">TEL AVIV</Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Pages/JerusalemPage">JERUSALEM</Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Pages/DeadSeaPage">EL MAR MUERTO</Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
              </ul>

              <ul>
                <li>
                  <Link className="first" to="/Pages/thingsToDo">
                    QUÉ HACER
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Posts/telaviv/Sensational_Beaches">
                    PLAYAS SENSACIONALES
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Posts/telaviv/Go_To_Guide">GUÍA</Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Posts/telaviv/Day_IsTrippin">
                    EXCURSIONES DE DÍA
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
              </ul>

              <ul className="">
                <li>
                  <Link className="first" to="/Pages/Videos">
                    VÍDEOS
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Posts/Videos/telaviv/TelAviv_On_Wheels">
                    AVENTURAS AL AIRE LIBRE
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Posts/Videos/deadsea/Natural_Spa">
                    EL MAR MUERTO
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
                <li>
                  <Link to="/Posts/Videos/telaviv/Port_Pleasures">
                    PLACERES PORTUARIOS
                  </Link>
                </li>
                <li className="show-on-mobile">
                  <a>|</a>
                </li>
              </ul>

              <div className="clear"></div>
            </div>
            <div className="clear"></div>
            {/* <div className="ac-wrapper-telaviv-and-jerusalem-footer ac-flex ac-flex-row ac-flex-row-mob">
              <div className="telaviv-and-jerusalem-footer">
                <a
                  className="jer-site"
                  href="https://www.itraveljerusalem.com/"
                  target="_blank"
                >
                  PÁGINA OFICIAL DE TURISMO DE JERUSALÉN >>
                </a>
              </div>
              <div className="ac-verti-line hide-on-mobile"> </div>
              <div className="telaviv-and-jerusalem-footer">
                <a
                  className="tlv-site"
                  href="https://visit.tel-aviv.gov.il/home"
                  target="_blank"
                >
                  PÁGINA OFICIAL DE TURISMO DE TEL AVIV >>
                </a>
              </div>
              <div className="telaviv-and-jerusalem-footer">
                <a
                  className="ac-privacy-policy"
                  href="https://en.citiesbreak.com/Posts/telaviv/Privacy_Policy"
                  target="_blank"
                >
                  PÓLIZA DE PRIVACIDAD >>
                </a>
              </div>
            </div> */}
          </div>
        </div>
        <div className="ac-social-wrapper">
                  <div className="ac-inner-social-wrapper">
                        <div className="ac-social-col ac-social-col-1">
                              <a href="https://www.instagram.com/visit_israel/" >
                              <Img desktopImg="social/i.png" mobileImg="social/i.png"/>
                              </a>
                        </div>
                        {/* <div className="ac-social-col ac-social-col-2">
                              <a href="https://twitter.com/israeltourism" onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'footer', 'click_cta':'twitter', 'event_details':'', }})}>
                              <Img desktopImg="social/t.png" mobileImg="social/t.png"/>
                              </a>
                        </div> */}
                        <div className="ac-social-col ac-social-col-3">
                              <a href="https://www.youtube.com/@goisraelofficial">
                              <Img desktopImg="social/y.png" mobileImg="social/y.png"/>
                              </a>
                        </div>
                        <div className="ac-social-col ac-social-col-4">
                              <a href="https://www.flickr.com/photos/israelphotogallery/sets/" >
                              <Img desktopImg="social/fl.png" mobileImg="social/fl.png"/>
                              </a>
                        </div>
                        <div className="ac-social-col ac-social-col-5">
                              <a href="https://www.facebook.com/VisitaIsrael" >
                              <Img desktopImg="social/f.png" mobileImg="social/f.png"/>
                              </a>
                        </div>
                        <div className="ac-social-col ac-social-col-6">
                              <a href="https://www.tiktok.com/@visit_israel" >
                              <Img desktopImg="social/tiktok.png" mobileImg="social/tiktok.png"/>
                              </a>
                        </div>
                        <div className="ac-social-col ac-social-col-7">
                              <a href="https://www.linkedin.com/company/israel-ministry-of-tourism/" >
                              <Img desktopImg="social/linkedin.png" mobileImg="social/linkedin.png"/>
                              </a>
                        </div>
                  </div>
        </div>
        <div className="row">
          <div className="cradit">
            <p>
              Fotógrafos: Guy Yehieli, Adam Primer, Kfir Boltin, Linnea Andres,
              Kfir Sivan, Haim Yafim, Dana Fridlander, refael Ben Ari, Itamar
              Greenberg, Moshik Lindbaum
            </p>
            <p>
              Créditos de los videos: Israeli food channel, Tel Aviv Jaffa
              municipality, UDINI prodactions
            </p>
          </div>

          {/* <h4>Para Más Ofertas:</h4> */}
          {/* <div className="clear"></div>
          <div className="sites-logos">
            <div className="anoter-site-deal-logo">
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://www.tripadvisor.co.uk/Hotels-g293984-Tel_Aviv_Tel_Aviv_District-Hotels.html"
              >
                <Img desktopImg={"Footer/1.png"} />
              </a>
            </div>

            <div className="anoter-site-deal-logo">
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://www.trivago.co.uk/?aDateRange%5Barr%5D=2016-10-13&aDateRange%5Bdep%5D=2016-10-14&r=&cpt=8494803&iRoomType=1&aPriceRange%5Bfrom%5D=0&aPriceRange%5Bto%5D=0&iPathId=84948&iViewType=0&bIsSeoPage=0&bIsSitemap=false"
              >
                <Img desktopImg={"Footer/2.png"} />
              </a>
            </div>

            <div className="anoter-site-deal-logo">
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://www.booking.com/city/il/tel-aviv.es.html?label=gen173nr-1FCAMoakIIdGVsLWF2aXZIM1gEaGqIAQGYATHCAQp3aW5kb3dzIDEwyAEM2AEB6AEB-AECkgIBeagCAw;sid=0d1d991c819c7da3b9cb4b8ffa69f869;inac=0;lang=es;soz=1;lang_click=other;cdl=en-gb"
              >
                <Img desktopImg={"Footer/3.png"} />
              </a>
            </div>

            <div className="anoter-site-deal-logo">
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://www.expedia.com/Oficina-De-Turismo-Tel-Aviv.d507139.Guia-Turistica?langid=2058"
              >
                <Img desktopImg={"Footer/4.png"} />
              </a>
            </div>

            <div className="anoter-site-deal-logo">
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://es.hoteles.com/de699178/hoteles-tel-aviv-israel/?pos=HCOM_ES&locale=es_ES"
              >
                <Img desktopImg={"Footer/5.png"} />
              </a>
            </div>
          </div> */}

          <div className="clear"></div>
        </div>
      </div>
      <div className="container container-links">
        <ul>
          <li><a href="https://brochures.goisrael.com/es/"
                 target="_blank"
              >FOLLETO OFICIAL</a></li>
          <li><span> | </span></li>
          <li><a href="https://goisrael.com/Pages/Contact/"
                target="_blank"
              >CONTACTO</a></li>
               <li><span> | </span></li>
          <li><a href="https://israel.travel/terms-of-use/"
                  target="_blank"
              >TÉRMINOS DE USO</a></li>
               <li><span> | </span></li>
          <li><a href="https://goisrael.com/Posts/telaviv/Privacy_Policy"
                  target="_blank"
              >
                  POLÍTICA DE PRIVACIDAD
                </a></li>
                 <li><span> | </span></li>
          <li><a href="https://es.goisrael.com/Pages/Gallery/" 
                 target="_blank" 
              >FOTOS</a></li>
               <li><span> | </span></li>
          <li><a href="https://es.goisrael.com/Posts/TouristInfo/Frequently_Asked_Questions"
                  target="_blank" 
              >PREGUNTAS FRECUENTES</a></li>
        </ul>
      </div>
      <br/>
    </div>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.js